import { DEFAULT_LISTING_FIELDS_CONFIG } from '../constants/defaultListingFieldsConfig';

export const cloneListingFieldsConfig = (config) => ({
  startPrice: config?.startPrice ?? DEFAULT_LISTING_FIELDS_CONFIG.startPrice,
  quantity: config?.quantity ?? DEFAULT_LISTING_FIELDS_CONFIG.quantity,
  conditionId: config?.conditionId ?? DEFAULT_LISTING_FIELDS_CONFIG.conditionId,
  customItemSpecifics: (config?.customItemSpecifics ?? []).map((item) => ({
    Name: item?.Name ?? '',
    Value: item?.Value ?? '',
  })),
  excludeItemSpecifics: [...(config?.excludeItemSpecifics ?? [])],
});

export const resolveListingFieldsConfig = (config) =>
  cloneListingFieldsConfig(config ?? DEFAULT_LISTING_FIELDS_CONFIG);
